import { render } from "./CardSeven.vue?vue&type=template&id=2b6945dc"
import script from "./CardSeven.vue?vue&type=script&lang=js"
export * from "./CardSeven.vue?vue&type=script&lang=js"

import "./CardSeven.vue?vue&type=style&index=0&id=2b6945dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__